module.exports = __webpack_public_path__ + "img/avatar-19.b7cdee46.png";